import { Box, Divider, Tooltip, Typography } from '@mui/material';
import { Order } from '../../apiTypes';
import { t } from '../../constants/translations';
import { useAdmin } from '../../contexts/admin.context';
import { useLocale } from '../../contexts/locale.context';
import currency from '../../utils/currency';

const CostPersent = ({ order }: { order: DbDocument<Order> }) => {
  const { cafe } = useAdmin();
  const { lang } = useLocale();

  if (!order.paid) {
    return null;
  }

  const totalCost = Object.values(order.items).reduce((acc, i) => acc + (i.cost || 0), 0);

  if (!totalCost) {
    return null;
  }

  const costPercent = Math.round((totalCost / order.paid.total) * 100);

  return (
    <Tooltip
      title={
        <Box>
          <Typography textAlign="center">{t.estimated_cost_price[lang]}</Typography>

          <Divider sx={{ my: 1, bgcolor: (t) => t.palette.grey[300] }} />

          {Object.values(order.items).map((item) => (
            <Typography key={item.id} variant="body2">{`${item.name}: ${currency(
              item.cost || 0,
              cafe?.currency,
              true
            )}`}</Typography>
          ))}
          <Divider sx={{ my: 1, bgcolor: (t) => t.palette.grey[300] }} />
          <Typography>{`${t.total[lang]}: ${currency(totalCost, cafe?.currency, true)}`}</Typography>
        </Box>
      }
    >
      <Typography
        textAlign="center"
        color={(t) => (costPercent < 50 ? t.palette.text.primary : t.palette.warning.main)}
      >
        {`${costPercent}%`}
      </Typography>
    </Tooltip>
  );
};

export default CostPersent;
